import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2173b393"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "working-sites-clocking-ins-section" }
const _hoisted_2 = { class: "body bg-white" }
const _hoisted_3 = { class: "title-section-spacing flex justify-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold block text-left" }, "Ultime timbrature", -1))
const _hoisted_5 = { class: "working-sites-clocking-ins overflow-x-auto" }
const _hoisted_6 = { class: "table whitespace-nowrap w-full" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Tipo", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Data", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Ora", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Effettuata da", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Azioni", -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "border-r-2 font-normal" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "border-r-2 font-normal" }
const _hoisted_20 = {
  key: 1,
  class: "border-r-2 font-normal"
}
const _hoisted_21 = {
  key: 2,
  class: "border-r-2 font-normal"
}
const _hoisted_22 = { class: "border-r-2 font-normal" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "font-normal" }
const _hoisted_26 = { class: "delete-document pl-4 tooltip" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-gray-500" }, "Non è stata inserita nessuna timbratura")
], -1))
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AddEditClockingInDialog = _resolveComponent("AddEditClockingInDialog")!
  const _component_DeleteClockinInDialog = _resolveComponent("DeleteClockinInDialog")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_PrimaryButton, {
            class: "bg-primary-900 edit-credential-data text-white",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowingClockingInDialog = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Aggiungi timbratura")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_ctx.scope == 1)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Nome Cantiere"))
                  : _createCommentVNode("", true),
                (_ctx.scope == 1)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Nome Blocco"))
                  : (_openBlock(), _createElementBlock("th", _hoisted_9, "Nome dipendente")),
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _hoisted_13,
                _hoisted_14
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clockingIns, (clockingIn) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  (_ctx.scope == 1)
                    ? (_openBlock(), _createElementBlock("th", {
                        key: 0,
                        class: "border-r-2 font-normal cursor-pointer",
                        onClick: ($event: any) => (_ctx.goToOrder(clockingIn.orderId))
                      }, _toDisplayString(clockingIn.orderName), 9, _hoisted_15))
                    : _createCommentVNode("", true),
                  _createElementVNode("th", _hoisted_16, [
                    (_ctx.scope == 1)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "cursor-pointer",
                          onClick: ($event: any) => (_ctx.goToWorkingSite(clockingIn.orderId, clockingIn.workingSiteId))
                        }, _toDisplayString(clockingIn.workingSiteName), 9, _hoisted_17))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "cursor-pointer",
                          onClick: ($event: any) => (_ctx.goToUser(clockingIn.userId))
                        }, _toDisplayString(clockingIn.userSurname) + " " + _toDisplayString(clockingIn.userName), 9, _hoisted_18))
                  ]),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(clockingIn.isClockingOut ? 'Uscita' : 'Entrata'), 1),
                  (clockingIn.createdTs)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(_ctx.moment.unix(clockingIn.createdTs).format("DD/MM/YYYY")), 1))
                    : _createCommentVNode("", true),
                  (clockingIn.createdTs)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.moment.unix(clockingIn.createdTs).format("HH:mm")), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_22, [
                    (clockingIn.createdByUserName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(clockingIn.createdByUserSurname) + " " + _toDisplayString(clockingIn.createdByUserName), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(clockingIn.createdByUserName) + " " + _toDisplayString(clockingIn.userSurname) + " " + _toDisplayString(clockingIn.userName), 1))
                  ]),
                  _createElementVNode("td", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "w-5 h-5 text-red-600 cursor-pointer hover:text-red-400",
                        icon: ['fas', 'trash'],
                        onClick: ($event: any) => (_ctx.deleteDocument(clockingIn)),
                        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingDeleteDialog = false))
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]))
              }), 256)),
              (_ctx.clockingIns.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_27, _hoisted_29))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isShowingClockingInDialog)
      ? (_openBlock(), _createBlock(_component_AddEditClockingInDialog, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowingClockingInDialog = false, this.isDeleting = false)),
          onCreated: _ctx.reloadClockingIns,
          id: _ctx.id,
          scope: _ctx.scope,
          user: _ctx.user,
          workingSite: _ctx.workingSite
        }, null, 8, ["onCreated", "id", "scope", "user", "workingSite"]))
      : _createCommentVNode("", true),
    (_ctx.isShowingDeleteDialog)
      ? (_openBlock(), _createBlock(_component_DeleteClockinInDialog, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowingDeleteDialog = false, this.isDeleting = true)),
          clockingInId: _ctx.document.id,
          date: _ctx.document.createdTs,
          "user-id": _ctx.document.userId,
          onReload: _ctx.reloadClockingIns
        }, null, 8, ["clockingInId", "date", "user-id", "onReload"]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 2,
          message: _ctx.isDeleting ? 'Eliminazione timbratura' :'Creazione timbratura'
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ], 64))
}